// extracted by mini-css-extract-plugin
module.exports = {"buttonRow":"StateTransitionWidgetDetailModal_buttonRow__3XAYC","buttonDiscard":"StateTransitionWidgetDetailModal_buttonDiscard__3ygnS"};